import { render } from "./read-category.vue?vue&type=template&id=1e51ded7&scoped=true"
import script from "./read-category.vue?vue&type=script&lang=js"
export * from "./read-category.vue?vue&type=script&lang=js"

import "./read-category.vue?vue&type=style&index=0&id=1e51ded7&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e51ded7"]])

export default __exports__